import React, { createContext, useContext } from "react";

/**
 * Which staff group the attendance tabs are showing.
 *
 * "instructor" is instructors on their own; "support" is support staff and
 * drivers together. A context rather than a prop because every tab (home,
 * permissions, leaves, reports, devices) needs it and each passes it into a
 * different hook.
 *
 * The default is "instructor", which is what the backend assumes when no group
 * is sent, so a tab rendered outside the provider behaves as it always did.
 */
export const STAFF_GROUPS = [
  { value: "instructor", label: "Instructors" },
  { value: "support", label: "Support Staff & Drivers" },
];

const StaffGroupContext = createContext("instructor");

export const StaffGroupProvider = ({ group, children }) => (
  <StaffGroupContext.Provider value={group}>
    {children}
  </StaffGroupContext.Provider>
);

export const useStaffGroup = () => useContext(StaffGroupContext);
